<template>
    <v-container class="pt-11 pb-4 text-center">
        <h1>
            {{ $t('pos.header') }}
        </h1>
        <hr class="my-4" style="width: 100px; border-color: #808080; margin: 0 auto">
        <p class="text-muted lead font-weight-normal">
            {{ $t('pos.description') }}
        </p>

        <v-tabs v-model="tab" background-color="transparent" centered>
            <v-tab href="#tab-payment"> {{ $t('pos.tabs.payment') }}</v-tab>
            <v-tab href="#tab-receiptPrinter"> {{ $t('pos.tabs.receiptPrinter') }}</v-tab>
            <v-tab href="#tab-cashDrawer"> {{ $t('pos.tabs.cashDrawer') }}</v-tab>
            <v-tab href="#tab-sale"> {{ $t('pos.tabs.sale') }}</v-tab>
            <v-tab href="#tab-productsSale"> {{ $t('pos.tabs.productsSale') }}</v-tab>
            <v-tab href="#tab-receipt"> {{ $t('pos.tabs.receipt') }}</v-tab>
            <v-tab href="#tab-startup"> {{ $t('pos.tabs.startup') }}</v-tab>
            <v-tab href="#tab-settlement"> {{ $t('pos.tabs.settlement') }}</v-tab>
            <v-tab href="#tab-customerDisplays"> {{ $t('pos.tabs.customerDisplays') }}</v-tab>
            <v-tab href="#tab-access"> {{ $t('pos.tabs.access') }}</v-tab>
        </v-tabs>

        <v-tabs-items v-model="tab">
            <v-tab-item value="tab-payment">
                <v-card flat>
                    <v-card-text class="font-italic">Empty</v-card-text>
                </v-card>
            </v-tab-item>
            <v-tab-item value="tab-receiptPrinter">
                <v-card flat>
                    <v-card-text class="font-italic">Empty</v-card-text>
                </v-card>
            </v-tab-item>
            <v-tab-item value="tab-cashDrawer">
                <v-card flat>
                    <v-card-text class="font-italic">Empty</v-card-text>
                </v-card>
            </v-tab-item>
            <v-tab-item value="tab-sale">
                <v-card flat>
                    <sale/>
                </v-card>
            </v-tab-item>
            <v-tab-item value="tab-productsSale">
                <v-card flat>
                    <product-sale/>
                </v-card>
            </v-tab-item>
            <v-tab-item value="tab-receipt">
                <v-card flat>
                    <v-card-text class="font-italic">Empty</v-card-text>
                </v-card>
            </v-tab-item>
            <v-tab-item value="tab-startup">
                <v-card flat>
                    <v-card-text class="font-italic">Empty</v-card-text>
                </v-card>
            </v-tab-item>
            <v-tab-item value="tab-settlement">
                <v-card flat>
                    <v-card-text class="font-italic">Empty</v-card-text>
                </v-card>
            </v-tab-item>
            <v-tab-item value="tab-customerDisplays">
                <v-card flat>
                    <v-card-text class="font-italic">Empty</v-card-text>
                </v-card>
            </v-tab-item>
            <v-tab-item value="tab-access">
                <v-card flat>
                    <v-card-text class="font-italic">Empty</v-card-text>
                </v-card>
            </v-tab-item>
        </v-tabs-items>

    </v-container>
</template>

<script>
   import Sale from './Tabs/Sale'
   import ProductSale from './Tabs/ProductSale'

   export default {
      name: 'pos',
      data: () => ({
         tab: 'tab-sale',
         pending: false
      }),
      components: { Sale, ProductSale },
      methods: {},
      computed: {}
   }
</script>

<style lang="scss">

</style>
